import ConversationWithUser from 'domain/conversations/ConversationWithUser';
import useDialogHandler from 'hooks/useDialogHandler';
import React from 'react';
import ChatWithUserIcon from 'ui/elements/icons/ChatBubblesIcon';
import cx from 'classnames';
import { useSelfUserProfile } from 'apis/CompanyAPI/users/useSelfUserProfile';
import { getOrUndefined } from 'util/resource';

interface Props {
  className?: string;
  user: { cwUserId: UUID };
  hasIcon?: boolean;
  link?: 'dark' | 'normal';
  /** See the prop of the same name on ConversationWithUser. */
  excludeEntityId?: number;
}
export default function ConversationLink({ user, className, hasIcon, link = 'dark', excludeEntityId }: Props) {
  const dialogHandler = useDialogHandler();
  const { resource: userProfileResource } = useSelfUserProfile();
  const isSelf = user.cwUserId === getOrUndefined(userProfileResource)?.cwUserId;

  return isSelf ? null : (
    <>
      <button
        className={cx(className, 'u-flex-align-center text-link-small', { ['text-link-dark']: link === 'dark' })}
        onClick={dialogHandler.open}
      >
        {hasIcon && <ChatWithUserIcon className="u-quarter-spacing-right" />}
        Chat
      </button>
      {dialogHandler.isOpen && (
        <ConversationWithUser
          conversation={{ type: 'withUsers', withCwUserIds: [user.cwUserId] }}
          closeConversation={dialogHandler.close}
          excludeEntityId={excludeEntityId}
        />
      )}
    </>
  );
}
